<p-dialog [header]="'pages.shipmentDetail.scheduleCorrection.title' | transloco" [(visible)]="visible" [modal]="true"
    [draggable]="false" [resizable]="false" [closable]="!saving"
    [style]="{ width: 'min(860px, 94vw)' }" [breakpoints]="{ '860px': '96vw' }"
    styleClass="master-create-dialog">
    <section class="master-dialog-body">
        <aside class="master-dialog-summary">
            <div class="summary-icon"><i class="pi pi-calendar-clock"></i></div>
            <div>
                <small>{{ 'pages.shipmentDetail.scheduleCorrection.eyebrow' | transloco }}</small>
                <h3>{{ shipment?.shipmentNumber }}</h3>
                <p>{{ 'pages.shipmentDetail.scheduleCorrection.summary' | transloco }}</p>
            </div>
            <div class="master-dialog-facts">
                <div><span>{{ 'pages.shipmentDetail.scheduleCorrection.currentPickup' | transloco }}</span><strong>{{ expectedPickupTime == null ? ('pages.shipmentDetail.scheduleCorrection.notScheduled' | transloco) : (expectedPickupTime | date:'dd-MM-yyyy HH:mm') }}</strong></div>
                <div><span>{{ 'pages.shipmentDetail.scheduleCorrection.currentDelivery' | transloco }}</span><strong>{{ expectedDropoffTime == null ? ('pages.shipmentDetail.scheduleCorrection.notScheduled' | transloco) : (expectedDropoffTime | date:'dd-MM-yyyy HH:mm') }}</strong></div>
                <div><span>{{ 'pages.shipmentDetail.scheduleCorrection.linkedStops' | transloco }}</span><strong>{{ 'pages.shipmentDetail.scheduleCorrection.matchingTimes' | transloco }}</strong></div>
            </div>
        </aside>

        <div class="master-dialog-form schedule-correction-form">
            <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-calendar-plus"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <p-datePicker inputId="schedule-pickup" [(ngModel)]="pickup" [showTime]="true"
                        (ngModelChange)="error = ''"
                        hourFormat="24" dateFormat="dd M yy" appendTo="body"
                        [disabled]="saving" styleClass="w-full"></p-datePicker>
                    <label for="schedule-pickup">{{ 'pages.shipmentDetail.scheduleCorrection.plannedPickup' | transloco }} *</label>
                </p-iftalabel>
            </p-inputGroup>
            <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-calendar-check"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <p-datePicker inputId="schedule-dropoff" [(ngModel)]="dropoff" [showTime]="true"
                        (ngModelChange)="error = ''"
                        hourFormat="24" dateFormat="dd M yy" appendTo="body"
                        [disabled]="saving" styleClass="w-full"></p-datePicker>
                    <label for="schedule-dropoff">{{ 'pages.shipmentDetail.scheduleCorrection.plannedDelivery' | transloco }} *</label>
                </p-iftalabel>
            </p-inputGroup>
            <p-inputGroup class="master-wide-field">
                <p-inputGroupAddon><i class="pi pi-pencil"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <textarea id="schedule-correction-reason" pTextarea [(ngModel)]="reason" rows="3"
                        (ngModelChange)="error = ''" maxlength="1000" [disabled]="saving"
                        [placeholder]="'pages.shipmentDetail.scheduleCorrection.reasonPlaceholder' | transloco"></textarea>
                    <label for="schedule-correction-reason">{{ 'pages.shipmentDetail.scheduleCorrection.reason' | transloco }} *</label>
                </p-iftalabel>
            </p-inputGroup>
            <small *ngIf="pickup && dropoff && dropoff <= pickup" class="p-error master-wide-field" role="alert">{{ 'pages.shipmentDetail.scheduleCorrection.dateOrder' | transloco }}</small>
            <small *ngIf="error" class="p-error master-wide-field save-error" role="alert">{{ error }}</small>
        </div>
    </section>
    <ng-template #footer>
        <div class="master-dialog-footer">
            <span class="footer-spacer"></span>
            <p-button [label]="'pages.shipmentDetail.scheduleCorrection.cancel' | transloco" icon="pi pi-times" severity="secondary" [outlined]="true"
                [disabled]="saving" (onClick)="visible = false"></p-button>
            <p-button [label]="'pages.shipmentDetail.scheduleCorrection.save' | transloco" icon="pi pi-save" [loading]="saving"
                [disabled]="!canSave" (onClick)="save()"></p-button>
        </div>
    </ng-template>
</p-dialog>
